import { afterNextRender, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'primeng/toast';
import { TransactionTimerComponent } from './shared/components/transaction-timer/transaction-timer.component';
import { NetworkStatusService } from './shared/services/network-status.service';

declare global {
  interface Window {
    __removeSplash?: () => void;
  }
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, TransactionTimerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  private networkStatus = inject(NetworkStatusService);
  private translate = inject(TranslateService);

  public isOnline = this.networkStatus.isOnline;
  public isConnectionSlow = this.networkStatus.isSlow;

  constructor() {
    this.translate.addLangs(['en', 'bn']);
    this.translate.setDefaultLang('bn');
    this.translate.use('bn');

    afterNextRender(() => window.__removeSplash?.());
  }

  ngOnInit() {
    const language: boolean = this.translate.currentLang === 'bn';
    if (language) {
      document.body.classList.add('bangali');
    }
  }
}
